<template>
  <button class="vsearchable-tile" :class="{ selected }" :disabled="disabled" @click="$emit('click')">
    <slot />
  </button>
</template>

<script lang="ts" setup>
defineProps({
  selected: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['click'])
</script>

<style lang="stylus" scoped>
.vsearchable-tile
  @apply w-full appearance-none bg-transparent text-left p-3 border-b border-gray-300

  &:hover
    @apply text-black bg-gray-450

  &.selected
    outline 1px solid theme('colors.copper.700')
    outline-offset -1px
    @apply bg-copper-100 text-copper-800
</style>
